module.exports = __webpack_public_path__ + "img/multiplayer.1d8dade3.png";